import service from '@/middleware'

const poiApi = {
    /**
     * Datos para la tabla del ABM
     * @param {*} pageSize
     * @param {*} pageNumber
     * @param {*} headers
     */
    async findAllPaginated(enterprises, pageSize, pageNumber, headers) {
        const url = pageSize != null && pageNumber != null
            ? `/api/poi/all?pageSize=${pageSize}&pageNumber=${pageNumber}&headers=${headers}`
            : `/api/poi/all?headers=${headers}`
        const response = await service.http.post(url, enterprises)
        return response
    },
    async findAll(enterprises) {
        const response = await service.http.post(
            `/api/poi/all`, enterprises)
        return response
    },
    /**
     * Total de zonas para el paginador de la tabla del ABM
     */
    async getTotal (enterprises) {
        const result = await service.http.post(`/api/poi/total`, enterprises)
        return result
    },
    /**
     * Para obtener una zona con el id enviado como param
     * @param {*} poiId
     */
    async getPoi (poiId) {
        const result = await service.http.get(`/api/poi/${poiId}`)
        return result
    },
    /**
     * Para crear una nueva zona
     * @param {*} poiDto
     */
    async create (poiDto) {
        const result = await service.http.post(`/api/poi/create`, poiDto)
        return result
    },
    /**
     * Para actualizar una zona
     * @param {*} poiDto
     */
    async update (poiDto) {
        const result = await service.http.put(`/api/poi/update`, poiDto)
        return result
    },
    /**
     * Para eliminar una zona
     * @param {*} id
     */
    async deleteOne (id) {
        const result = await service.http.delete(`/api/poi/${id}`)
        return result
    },
    /**
     * Eliminación múltiple
     * @param {*} ids 
     */
    async deleteMany (ids) {
        const result = await service.http.put(`/api/poi/multiple-delete`, ids)
        return result
    },
    async getCategories(enterpriseId) {
        return await service.http.get(`/api/poi/categories/${enterpriseId}`)
    },
    /**
     * Valida que para actualizar el valor "puntos de interés" del selector en el diálogo AMB categorías no existan puntos de interés con dicha categoría
     */
    async validatePois(categoryId) {
        const result = await service.http.get(`/api/poi/count-by-category/${categoryId}`)
        return result
    }
}

export default poiApi
